<template>

    <div>
        <div class="row row-cols-1 row-cols-lg-2 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Property') }}</legend>
                            <text-input label="Name" v-model="form.name" :error="form.errors.name" />
                            <text-input label="slug" v-model="form.slug" :error="form.errors.slug" />
                            <select-input label="Type" v-model="form.property_type" :error="form.errors.property_type">
                                <option :value="k" v-for="(v, k) in propertyTypeOptions">{{ v }}</option>
                            </select-input>
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Misc') }}</legend>
                            <!--                       @todo     <select-input label="sorting_type" v-model="form.sorting_type" :error="form.errors.sorting_type">
                                                            <option :value="k" v-for="(v, k) in sortingTypeOptions">{{ v }}</option>
                                                        </select-input>-->
                            <textarea-input label="description" v-model="form.description" :error="form.errors.description" />
                            <checkbox-input label="filterable" v-model="form.filterable" :error="form.errors.filterable" />
                            <checkbox-input label="visible_on_product_page" v-model="form.visible_on_product_page" :error="form.errors.visible_on_product_page" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="property">
                    {{ __('Löschen') }}
                </button>
            </div>

        </div>

    </div>

</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'property',
            'propertyTypeOptions',
            'sortingTypeOptions',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {
            destroy() {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.properties.destroy', this.property));
                }
            },
        },
    }
</script>
